var map = {
	"./cristina-gottardi-CSpjU6hYo_0-unsplash-1920.jpg": 85498,
	"./riccardo-chiarini-gYCMiZp-A7E-unsplash-1920.jpg": 28919,
	"./timo-wagner-FTudIwhTfUU-unsplash-1920.jpg": 51202,
	"./v2osk-1Z2niiBPg5A-unsplash-1920.jpg": 37262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29204;